<template>
    <app-layout title="Add Product">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Add Product</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button :disabled="form.processing" :href="route('products.index')">
                        Cancel
                    </jet-tertiary-button>
                </template>
            </page-header>

            <product-form
                v-bind="{
                    product,
                    categories,
                    pricingLevels,
                    location,
                    master_products,
                    unit_of_measures,
                    form,
                    productsForContentsSelect,
                    brands,
                    sfd_product_count,
                    purchasers
                }"
                class="px-8 mb-4"
            />
        </form>

        <jet-confirmation-modal :show="showCancelModal" @close="showCancelModal=false">
            <template #title>
                Cancel without saving?
            </template>

            <template #content>
                Product has not been saved yet, are you sure you would like to cancel?
            </template>

            <template #footer>
                <jet-tertiary-button @click="showCancelModal=false">
                    No
                </jet-tertiary-button>

                <jet-danger-button class="ml-2" @click="cancelCreate" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Yes
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </app-layout>
</template>

<script>
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import ProductForm from '@/Pages/Product/Partials/ProductForm.vue';
import { useForm } from '@inertiajs/inertia-vue3';

export default {
    setup (props) {
        let pricing = [];

        props.pricingLevels.forEach(l => {
            pricing.push({
                product_id: null,
                pricing_level_id: l.id,
                pricing_level_title: l.title,
                price: null,
                modifier_type: null,
                modifier_amount: null,
            });
        });

        const form = useForm({
            id: null,
            is_wholesale: true,
            category_id: null,
            title: '',
            description: '',
            long_description: '',
            custom_sold_out_message: '',
            size: '',
            length: null,
            width: null,
            height: null,
            hot_buy: false,
            local: false,
            special_order: false,
            special_order_lead_hours: null,
            retail_special: false,
            allow_oversell: false,
            processed: false,
            taxable: false,
            sfd_product: false,
            sfd_product_number: null,
            allow_partial_quantity: false,
            enabled: true,
            image: null,
            images: [],
            cost: null,
            market_cost: null,
            price: null,
            price_2plus: null,
            pricing: pricing,
            zone: null,
            subzone: null,
            retail_zone: null,
            retail_subzone: null,
            school_zone: null,
            school_subzone: null,
            stock: 0,
            gift_card: null,
            prc_promo_code_exempt: false,
            new: null,
            organic: false,
            clearance: false,
            spotlight: false,
            milk_crate: false,
            brand_id: null,
            brand_new: null,
            contents: null,
            sort_by: null,
            unit: null,
            require_subitem_quantities: false,
            include_subitems_on_picksheet: false,
            subproducts: [],
            max_order_qty: null,
            store_excludes: null,
            is_master_product: false,
            related_master_product_id: null,
            conversion_factor: null,
            unit_of_measure_id: null,
            picksheet_highlights: '',
            purchaser_id: null,
            free_for_orders_over_enabled: false,
            free_for_orders_over_amount: 0,
            base_retail_price: props.product.base_retail_price,
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetDangerButton,
        JetTertiaryButton,
        ProductForm,
    },

    props: [
        'location',
        'productsForContentsSelect',
        'brands',
        'product',
        'categories',
        'pricingLevels',
        'sfd_product_count',
        'master_products',
        'unit_of_measures',
        'purchasers'
    ],

    data() {
        return {
            showCancelModal: false,
        }
    },

    methods: {
        submit() {
            this.form.transform((data) => ({
                ...data,
                sort_by: data.is_wholesale ? null : data.sort_by,
                contents: data.is_wholesale ? null : data.contents,
                retail_zone: data.is_wholesale ? null : data.retail_zone,
                retail_subzone: data.is_wholesale ? null : data.retail_subzone,
                new: data.is_wholesale ? 0 : data.new,
                brand_id: data.is_wholesale ? null : data.brand_id,
                gift_card: data.is_wholesale ? 0 : data.gift_card,
                max_order_qty: data.is_wholesale ? null : data.max_order_qty,
                price_2plus: data.is_wholesale ? null : data.price_2plus,
                store_excludes: data.is_wholesale ? null : data.store_excludes,
                retail_special: data.is_wholesale ? 0 : data.retail_special,
            })).post(route('products.store'))
        },

        cancelCreate() {
            this.$inertia.get(route('products.index'));
        },
    }
}
</script>

<style scoped></style>
